<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}矩陣題
    </template>

    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        label="題目內容"
        auto-grow
        v-on:click="checkDef()"
        v-model="ques.cnName"
        class="peter-text"
      ></v-textarea>
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>
      <!-- <v-row v-if="isEdit">
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            dense
            label="縱軸項目"
            v-model="tmpItem"
            outlined
            class="centered-input peter-text"
          ></v-text-field>
        </v-col>
        <div class="mt-3"><v-btn @click="addItem">增加項目</v-btn></div>
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            dense
            label="橫軸選項"
            v-model="tmpOpt"
            outlined
            class="centered-input peter-text"
          ></v-text-field>
        </v-col>
        <div class="mt-3"><v-btn @click="addOption">增加選項</v-btn></div>
      </v-row> -->
      <!-- 用 computed subQues，會比 ques.subQues 多一個空元素，用做增加欄位 -->
      <v-data-table
        :headers="ques.items"
        hide-default-header
        :items="subQues"
        hide-default-footer
        class="mt-5"
      >
        <template slot="header" slot-scope="props">
          <!-- Debug -->
          <!-- <div>props:{{ props }}</div> -->
          <thead class="v-data-table-header">
            <tr>
              <th
                role="columnheader"
                scope="col"
                aria-label="項目"
                aria-sort="none"
                class="text-center"
              >
                <span>項目</span>
              </th>
              <th
                v-for="(head, idx) in props.props.headers"
                :key="idx"
                role="columnheader"
                scope="col"
                :aria-label="head"
                aria-sort="none"
                class="text-center"
              >
                <span class="matrix-text">{{ head }}</span>
                <v-btn
                  v-if="isEdit"
                  fab
                  dark
                  x-small
                  color="primary"
                  @click="delOption(idx)"
                  class="mb-2 ml-1"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </th>
              <th class="text-center" v-if="isEdit">
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      label="增加"
                      solo
                      dense
                      v-model="tmpOpt"
                      class="peter-text"
                    ></v-text-field>
                  </v-col>
                  <v-btn fab dark x-small color="primary" @click="addOption" class="ml-1">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-row>
              </th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <!-- 對於每一個 row 加上 tr 不然不會換行 -->
          <tr v-if="props.index < ques.subQues.length">
            <!-- Debug -->
            <!-- props: -->
            <!-- {{ props }} -->
            <td class="text-center">
              <span class="matrix-text">{{ props.item.cnName }}</span>
              <v-btn
                v-if="isEdit"
                fab
                dark
                x-small
                color="primary"
                @click="delItem(props.index)"
                class="ml-1"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </td>
            <td
              v-for="(header, idx) in ques.items"
              :key="idx"
              class="text-center pa-0 matrix-item-td"
              @click="ques.subQues[props.index].value = idx"
            >
              <!-- 這裡 props 的就是 slot 說明裡面的那個物件 -->
              <!-- props.index 就是目前道第幾個物件(渲染 row 的 item slot 第幾次被呼叫，0base) -->
              <!-- props.item 就是 ques.subQues[props.index] -->
              <v-radio-group
                v-model="ques.subQues[props.index].value"
                class="peter-matrix-item-radio"
              >
                <v-radio :value="idx"></v-radio>
              </v-radio-group>
            </td>
          </tr>
          <tr v-else-if="isEdit">
            <td>
              <v-row no-gutters>
                <v-col>
                  <v-text-field
                    label="增加"
                    solo
                    dense
                    v-model="tmpItem"
                    class="peter-text"
                  ></v-text-field>
                </v-col>
                <v-btn fab dark x-small color="primary" @click="addItem" class="ml-1">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard,
  },
  data() {
    return {
      tmpOpt: '',
      tmpItem: '',
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          cnName: '對下列餐點的喜好程度',
          items: [], // 矩陣題的選項
          subQues: [], // 矩陣題的子題
        }
      },
    },
  },
  computed: {
    subQues() {
      return this.ques.subQues.concat([{}])
    },
    QType() {
      return this.$store.state.QType
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    addOption() {
      if (this.tmpOpt.length > 0) {
        this.ques.items.push(this.tmpOpt)
        this.tmpOpt = ''
      }
    },
    addItem() {
      if (this.tmpItem.length > 0) {
        this.ques.subQues.push({ rowId: null, cnName: this.tmpItem, value: null })
        this.tmpItem = ''
      }
    },
    delOption(idx) {
      this.ques.items.splice(idx, 1)
    },
    delItem(idx) {
      this.ques.subQues.splice(idx, 1)
    },
    checkDef() {
      if (this.QType.MATRIX.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }
    },
  },
}
</script>

<style>
.matrix-item-td {
  cursor: pointer;
}
.peter-matrix-item-radio {
  display: inline-block;
  cursor: pointer;
}
.matrix-text {
  font-weight: 400;
  font-size: 18px;
}
</style>
